import(/* webpackMode: "eager", webpackExports: ["ArticleView"] */ "/workspace/src/components/article-view.tsx");
